import { makeStyles } from '@material-ui/core/styles';
import { zambianColors } from './zambianTheme';

type Props = {
  height?: number;
  /** When true, renders a thinner stripe (2px) suitable as a section divider. */
  thin?: boolean;
};

const useStyles = makeStyles({
  root: {
    display: 'flex',
    width: '100%',
    overflow: 'hidden',
  },
  band: {
    flex: 1,
  },
});

/**
 * A four-band horizontal accent stripe inspired by the Zambian flag.
 * Order matches the flag's eagle stripes: red, black, orange — with green
 * leading as the dominant national colour.
 */
export const BrandStripe = ({ height, thin }: Props) => {
  const classes = useStyles();
  const h = height ?? (thin ? 2 : 6);
  return (
    <div className={classes.root} style={{ height: h }} aria-hidden>
      <div
        className={classes.band}
        style={{ background: zambianColors.green }}
      />
      <div className={classes.band} style={{ background: zambianColors.red }} />
      <div
        className={classes.band}
        style={{ background: zambianColors.black }}
      />
      <div
        className={classes.band}
        style={{ background: zambianColors.orange }}
      />
    </div>
  );
};
